import { Masks } from "@hooks/functions/Masks/Masks";
import { getRaffleStatus } from "@hooks/functions/Raffle/status";
import { getRaffleType } from "@hooks/functions/Raffle/type";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import { ITicketCampaign } from "../types";
import { formatName } from "@hooks/functions/formatName";

interface IProps {
  campaign: ITicketCampaign;
  onClose: () => void;
}

const masks = new Masks();

export function CampaignDetailsModal({ campaign, onClose }: IProps) {
  const [animate, setAnimate] = useState(false);

  const status = getRaffleStatus(campaign.status);
  const type = getRaffleType(campaign.type);

  const details = [
    { label: "Key da Campanha", value: campaign.key },
    { label: "Slug da Campanha", value: campaign.campaign },
    {
      label: "Tickets Adquiridos",
      value: masks.formatMilhar(campaign.acquiredTickets),
    },
    {
      label: "Criação",
      value: dayjs(campaign.createdAt).format("DD/MM/YYYY [às] HH:mm"),
    },
    { label: "Status", value: status.text },
    { label: "Tipo", value: type.text },
    { label: "Total de Tickets", value: masks.formatMilhar(campaign.quantity) },
    {
      label: "Total vendido",
      value: masks.formatMilhar(campaign.ticketSoldAmount),
    },
    {
      label: "Premiação Total",
      value: masks.brlCurrency(campaign.rewardPriceMarket),
    },
    {
      label: "Proprietário",
      value: `${formatName(campaign?.owner?.name || "")} (@${campaign.owner.atSign})`,
    },
    {
      label: "Percentual Vendido",
      value: `${campaign.ticketSoldProgress.toFixed(2)}%`,
    },
    { label: "Preço Unitário", value: masks.brlCurrency(campaign.price) },
  ];

  function handleClose() {
    setAnimate(false);
    setTimeout(() => onClose(), 300);
  }

  useEffect(() => {
    setTimeout(() => setAnimate(true), 10);

    function handleEscapeClose() {
      setAnimate(false);
      setTimeout(() => onClose(), 300);
    }

    function handleEscape(evt: KeyboardEvent) {
      if (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27) {
        handleEscapeClose();
      }
    }

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  return (
    <>
      <div
        className={`modal fade ${animate ? "show" : ""}`}
        style={{ display: "block" }}
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div>
                <h5 className="modal-title fw-bold mb-1">{campaign.name}</h5>
                <small className="text-muted">
                  {campaign.description_short}
                </small>
              </div>
              <button
                type="button"
                className="btn-close"
                aria-label="Fechar"
                onClick={handleClose}
              />
            </div>
            <div className="modal-body">
              <div className="row g-3">
                {details.map((detail) => (
                  <div className="col-12 col-md-6" key={detail.label}>
                    <div className="border rounded p-3 h-100 bg-light">
                      <small className="text-muted d-block mb-1">
                        {detail.label}
                      </small>
                      <span className="fw-semibold">{detail.value}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={`modal-backdrop fade ${animate ? "show" : ""}`}></div>
    </>
  );
}
